export const dark = {
    bg:       '#0f0f0f',
    surface:  '#1a1a1a',
    surface2: '#242424',
    border:   '#2e2e2e',
    text:     '#e8e8e8',
    text2:    '#888',
    text3:    '#555',
}

export const font = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

export const btn = {
    primary: {
        background: '#f0f0f0',
        color: '#111',
        border: 'none',
        borderRadius: '6px',
        padding: '10px 20px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '13px',
        fontFamily: font,
        letterSpacing: '0.3px',
    },
    outline: {
        background: 'transparent',
        color: '#e8e8e8',
        border: '1.5px solid #3a3a3a',
        borderRadius: '6px',
        padding: '9px 18px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '13px',
        fontFamily: font,
        letterSpacing: '0.3px',
    },
    ghost: {
        background: 'transparent',
        color: '#888',
        border: '1px solid #2e2e2e',
        borderRadius: '6px',
        padding: '9px 18px',
        cursor: 'pointer',
        fontWeight: '500',
        fontSize: '13px',
        fontFamily: font,
    },
    danger: {
        background: 'transparent',
        color: '#e05555',
        border: '1.5px solid #e05555',
        borderRadius: '6px',
        padding: '9px 18px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '13px',
        fontFamily: font,
    }
}

export const card = {
    background: '#1a1a1a',
    borderRadius: '10px',
    border: '1px solid #2e2e2e',
    padding: '20px',
    marginBottom: '12px',
}

export const taskStateMap = {
    0: { label: 'Esperando',              dot: '#FA4C4C' },
    1: { label: 'Esperando',              dot: '#FA4C4C' },
    2: { label: 'Reparado',               dot: '#4cc488' },
    3: { label: 'Esperando repuesto',     dot: '#d4d457' },
    4: { label: 'Sin reparar',            dot: '#666' },
    5: { label: 'RMA',                    dot: '#ff9966' },
    6: { label: 'Pendiente confirmación', dot: '#87CEEB' },
    7: { label: 'En tránsito',            dot: '#5b8dee' },
}

export const shippingSteps = [
    { key: 1, label: 'Enviado por cliente' },
    { key: 2, label: 'En tránsito' },
    { key: 3, label: 'Recibido en taller' },
]
